import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

// see https://create-react-app.dev/docs/adding-bootstrap/#using-a-custom-theme
// import 'bootstrap/dist/css/bootstrap.min.css';
import './custom.scss';

ReactDOM.render(<App />, document.getElementById('planpoint-root'));
